import apiClient from './apiClient'

/**
* Get warehouses
* @returns
*/
export const getWarehouses = async () =>
	await apiClient.get('/api/warehouses')
